import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 2v20M3.34 7l17.32 10M3.34 17 20.66 7M9.5 3 12 5.5 14.5 3m-5 18 2.5-2.5 2.5 2.5m4.04-15.66-.91 3.41 3.41.92m0 4.66-3.41.92.91 3.42m-13.08 0 .91-3.42-3.41-.92m0-4.66 3.41-.92-.91-3.41"
    }, null, -1)
  ])))
}
export default { render: render }